// extracted by mini-css-extract-plugin
export default {"zoomModal":"DZ-z","image":"EZ-z","button":"FZ-z","isOverlayShown":"GZ-z"};